export default __webpack_public_path__ + "static/location-pin-a5c629d593980f1d641d44cd70ba03e2.png";